import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import axiosClient from '../utils/axiosClient';

export const useSaveBulkExtractMutation = () => {
  return useMutation<
    { id: number },
    AxiosError<any>,
    {
      file: File;
      filtered: boolean;
    }
  >(
    ({ file, filtered }) => {
      const body = new FormData();
      body.append('file', file);
      body.append('filtered', filtered ? '1' : '0');

      return axiosClient
        .post(`/execution/bulkExtract`, body, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
